import classnames from 'classnames';
import React, { useRef } from 'react';
import { useScaleCursor } from '@/utils/cursor-kit';

interface ScaleActionsProps {
    rotate: number;
}
const ImageScaleAction = (props: ScaleActionsProps) => {
    const { rotate } = props;
    const backSlashCursorNodeRef = useRef<HTMLSpanElement>(null);
    const slashCursorNodeRef = useRef<HTMLSpanElement>(null);
    const cursor = useScaleCursor(rotate);

    return (
        <div className="l-cropImage-scaleAction-img">
            <span ref={backSlashCursorNodeRef}>
                <div
                    className={classnames('vertex lt', {
                        [cursor.LT]: true,
                    })}
                    data-operate-type="crop-img-scale-lt"
                />
                <div
                    className={classnames('vertex rb', {
                        [cursor.RB]: true,
                    })}
                    data-operate-type="crop-img-scale-rb"
                />
            </span>

            <span ref={slashCursorNodeRef}>
                <div
                    className={classnames('vertex lb', {
                        [cursor.LB]: true,
                    })}
                    data-operate-type="crop-img-scale-lb"
                />
                <div
                    className={classnames('vertex rt', {
                        [cursor.RT]: true,
                    })}
                    data-operate-type="crop-img-scale-rt"
                />
            </span>
        </div>
    );
};

export default ImageScaleAction;
